import React, { MouseEventHandler, ReactNode } from 'react'

import Box from 'components_new/atoms/Box'
import CardActionArea from 'components_new/atoms/Card/CardActionArea'
import Icon, { IconProps } from 'components_new/atoms/Icon'
import Text from 'components_new/atoms/Text'

interface ButtonFieldProps {
  background?: boolean
  body?: ReactNode
  className?: string
  disableBorder?: boolean
  disableBorderRadius?: boolean
  editMode?: boolean
  fullHeight?: boolean
  fullWidth?: boolean
  height?: number
  icon?: IconProps
  onClick?: (() => void) | MouseEventHandler<HTMLElement>
  onMouseDown?: (() => void) | MouseEventHandler<HTMLElement>
  orientation?: 'horizontal' | 'vertical'
  sx?: object
  title?: string
}

const ButtonField = (props: ButtonFieldProps) => {
  const {
    background,
    body,
    disableBorder,
    disableBorderRadius,
    editMode,
    fullHeight,
    fullWidth,
    height,
    icon,
    orientation,
    onClick,
    onMouseDown,
    sx,
    title
  } = props

  return (
    <Box
      className={props.className}
      sx={{
        bgcolor: background ? 'background.default' : undefined,
        ...(!disableBorder
          ? {
              border: editMode ? '1px solid' : '1px dashed',
              borderColor: editMode ? 'primary.main' : 'divider'
            }
          : null),
        borderRadius: disableBorderRadius ? 0 : 1,
        maxHeight: height ? `${height}px!important` : undefined,
        minHeight: height ? `${height}px!important` : undefined,
        height: fullHeight ? '100%' : height ?? 'fit-content',
        width: fullWidth ? '100%' : undefined,
        ...sx
      }}
    >
      <CardActionArea
        component="button"
        onClick={onClick}
        onMouseDown={onMouseDown}
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: orientation === 'horizontal' ? 'row' : 'column',
          gap: '1em',
          height: '100%',
          justifyContent:
            orientation === 'horizontal' ? 'flex-start' : undefined,
          p: 1,
          textWrap: 'wrap',
          width: '100%'
        }}
      >
        <Icon fontSize="small" name="AddCircleOutlineOutlined" {...icon} />
        {body || title ? (
          <Box
            sx={{
              alignItems:
                orientation === 'horizontal' ? 'flex-start' : 'center',
              display: 'flex',
              flexDirection: 'column',
              gap: orientation === 'horizontal' ? '0.25em' : '1em',
              justifyContent:
                orientation === 'horizontal' ? 'flex-start' : undefined,
              textWrap: 'wrap'
            }}
          >
            {title ? (
              <Text color="text.primary" component="div" variant="navigation">
                {title}
              </Text>
            ) : null}
            {body ? (
              <Text color="text.secondary" component="div" variant="body2">
                {body}
              </Text>
            ) : null}
          </Box>
        ) : null}
      </CardActionArea>
    </Box>
  )
}

export default ButtonField
